import type { FAQItem } from "@/components/seo/faq-types";
import { Link } from "react-router-dom";

export const bathroomFaqItems: FAQItem[] = [
  {
    id: "1",
    question: "Are these bathroom products actually commercial-grade or just retail-ranges?",
    answerText:
      "Yes, we have a selection of bathroom fixtures for commercial and high-use environments, not just for one-off residential installs. That means durable finishes, repeatable SKUs, and commercial warranties suitable for apartment complexes, hospitality, aged care, schools, and offices. Talk to our team about specifying the right range for your project.",
    answerNode: (
      <>
        Yes, we have a selection of bathroom fixtures for <strong>commercial and high‑use environments</strong>, not just for one‑off residential installs. That means durable finishes, repeatable SKUs, and commercial warranties suitable for apartment complexes, hospitality, aged care, schools, and offices.{" "}
        <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Talk to our team about specifying the right range
        </Link>.
      </>
    ),
  },
  {
    id: "2",
    question: "Can you supply the same fixtures consistently across a multi-unit or multi-site project",
    answerText:
      "Absolutely. We can offer spec consistency - supplying the same taps, vanities, toilets, and mixers across multiple units or locations, even when projects are staged. Contact one of our dedicated account managers to learn more about what this looks like.",
    answerNode: (
      <>
        Absolutely. We can offer spec consistency — supplying the same taps, vanities, toilets, and mixers across multiple units or locations, even when projects are staged.{" "}
        <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Contact one of our dedicated account managers
        </Link> to learn more about what this looks like.
      </>
    ),
  },
  {
    id: "3",
    question: "Do you work with builders, plumbers, architects, and procurement teams - or just end customers?",
    answerText:
      "We work primarily with trade and commercial customers, including builders, plumbers, quantity surveyors, developers, architects, designers, and procurement managers. You'll deal with a dedicated commercial account manager, not a retail counter. Get in touch to discuss your project requirements.",
    answerNode: (
      <>
        We work primarily with <strong>trade and commercial customers</strong>, including builders, plumbers, quantity surveyors, developers, architects, designers, and procurement managers. You’ll deal with a <strong>dedicated commercial account manager</strong>, not a retail counter.{" "}
        <Link to="/contact-us" className="text-blue-600 underline hover:text-blue-800">
          Get in touch to discuss your project requirements
        </Link>.
      </>
    ),
  },
  {
    id: "4",
    question: "How do your prices compare to plumbing merchants or specialist suppliers?",
    answerText:
      "Our pricing is trade-based and volume-aligned, with project pricing available for multi-unit builds and commercial fit-outs. We focus on total value, pricing, availability, logistics, and reduced rework. Ask for a project quote or comparison.",
    answerNode: (
      <>
        Our pricing is <strong>trade‑based and volume‑aligned</strong>, with project pricing available for multi‑unit builds and commercial fit‑outs. We focus on <strong>total value</strong>, pricing, availability, logistics, and reduced rework.{" "}
        <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Ask for a project quote or comparison
        </Link>.
      </>
    ),
  },
  {
    id: "5",
    question: "Can you deliver to site, staged, and nationwide?",
    answerText:
      "Yes. We offer nationwide delivery across New Zealand, including staged drops aligned to build programmes and handover timelines. Get confirmed delivery timelines with our commercial team.",
    answerNode: (
      <>
        Yes. We offer <strong>nationwide delivery</strong> across New Zealand, including <strong>staged drops</strong> aligned to build programmes and handover timelines.{" "}
        <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
          Get confirmed delivery timelines with our commercial team
        </Link>.
      </>
    ),
  },
  {
    id: "6",
    question: "Are these fixtures suitable for aged care, hospitality, and public bathrooms?",
    answerText:
      "They are. Our bathroom range includes products suitable for high-traffic and regulated environments, including aged care, hospitality, education, healthcare, offices, and shared amenities. Let us know your use case and compliance needs.",
    answerNode: (
      <>
        They are. Our bathroom range includes products suitable for <strong>high‑traffic and regulated environments</strong>, including aged care, hospitality, education, healthcare, offices, and shared amenities. Let us know your use case and compliance needs.
      </>
    ),
  },
  {
    id: "7",
    question: "What happens if we need replacements or matching items later?",
    answerText:
      "We work with you to prioritise ranges with long-term availability and consistent specifications, making it easier to source replacements or add units later without mismatches. Talk to us about future-proofing your bathroom spec.",
    answerNode: (
       <>
    We work with you to prioritise ranges with long‑term availability and consistent specifications, making it easier to source replacements or add units later without mismatches.{" "}
    <Link to="/about-us#team-finder" className="text-blue-600 underline hover:text-blue-800">
      Talk to us about future‑proofing your bathroom spec
    </Link>.
  </>
    ),
  },
];